// extracted by mini-css-extract-plugin
export var chevronIcon = "_cu-2";
export var teamName = "_cu-1";
export var teamSwitcherButton = "_cu-0";